import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  AddressesApiResponse,
  AddressSearchParams,
  AddressSearchResult,
} from '../../models/mailarchiv/address.model';
import { ApiEnvelope } from '../../helpers/api-envelope.helper';
@Injectable({
  providedIn: 'root',
})
export class AddressService {
  constructor(private http: HttpClient) {}

  search(params: AddressSearchParams): Observable<AddressSearchResult> {
    return this.http
      .post<AddressesApiResponse | ApiEnvelope<AddressesApiResponse>>(environment.apiUrl + '/addresses', params)
      .pipe(
        map((res) => {
          const payload = 'data' in res ? res.data : res;
          const a = payload.addresses;
          return {
            hits: a.hits ?? [],
            estimatedTotalHits: a.estimatedTotalHits,
            limit: a.limit,
            offset: a.offset,
          };
        })
      );
  }
}
